import React, { useContext, useEffect, useState } from "react"
import IconButton from "@mui/material/IconButton"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Divider from "@mui/material/Divider"
import { useSelector } from "react-redux"
import { MocImage } from "./TwoSplitLayout"
import { dashboardStyles } from "resources/styles/pages/DashboardStyles"
import { useTheme } from "@emotion/react"
import { useHistory } from "react-router"
import { MocUserRole } from "core/services/models/Enums"
import { CognitoOTPAuthContext } from "cognito/CognitoOTPAuthContext"
import { useLocation } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleUser } from "@fortawesome/free-regular-svg-icons"


const ITEM_HEIGHT = 48

type Activity = {
  options: Array<any>
  handleClick: any
  icon?: any
  setSwitchRole?: any
  fcmToken?: any
  staffData?: any
  getAllCenterDetails?: any
}

export const VSStyledMenu = (props: Activity) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [profilePic, setProfilePic] = useState<any>("")

  const { logout } = useContext(CognitoOTPAuthContext);

  const open = Boolean(anchorEl);

  const theme = useTheme()
  const classes = dashboardStyles(theme)

  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const history = useHistory()
  const location = useLocation()


  const queryParameters = new URLSearchParams(window?.location?.search);
  const medicalRecordId = queryParameters.get("medicalRecordId");

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    props.getAllCenterDetails()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event: any) => {
    setAnchorEl(null)
    props.handleClick(event)
  }

  const redirectToProfile = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (userRole === MocUserRole.PATIENT) {
      history.push(`/editPatient/${userDetail?.id}`)
    }
    else if (location.pathname === "/myProfile") {
      history.replace("/myProfile")
    }
    else {
      history.push(`/myProfile`)
    }
  };

  useEffect(() => {
    const profilePicUrl: any = sessionStorage.getItem("profilePicUrl")
    if (profilePicUrl) {
      setProfilePic(profilePicUrl)
    }
    else if (props?.staffData) {
      setProfilePic(props?.staffData?.consultantProfilePic)
    }

    // setProfilePic("/assets/images/user.png")
  }, [props?.staffData])

  return (
    <>
      <IconButton
        style={{ fontSize: "12px", gap: "5px", borderRadius: "unset !important" }}
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <div className="d-flex align-items-center">
          {profilePic ? (
            <MocImage
              className={`${classes.userImage}`}
              src={profilePic}
            />
          ) : (
            props.icon ? props.icon : <FontAwesomeIcon icon={faCircleUser} size="3x" />
          )}
        </div>
        <div>
          <div className={classes.userName}>{userDetail?.name}</div>
          <div className={classes.userRole}>{userRole}</div>
        </div>
      </IconButton>
      <div className="mt-5">
        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "18ch",
            },
          }}
        >
          {props.options.map((option, index) => {
            // Exclude "Profile" option if "medicalrecord" is present
            if (option?.props?.children?.props?.children[1] === "Profile" && medicalRecordId) {
              return null;
            }

            return (
              <div key={`menu-${option.textContent}-${index}`}>
                <MenuItem
                  id={option.textContent}
                  key={option.textContent}
                  onClick={(e: any) => {
                    if (index === props?.options?.length - 2) {
                      redirectToProfile(e);
                    } else if (index === props?.options?.length - 1) {
                      logout();
                    }
                    else if (index === props?.options?.length - 3) {
                      props?.setSwitchRole(true)
                      setAnchorEl(null)
                    }
                    handleClose(e)
                  }}
                >
                  {option}
                </MenuItem>

                {index < props.options.length - 1 && (
                  <Divider
                    style={{
                      padding: "0px",
                      marginLeft: "10px",
                      marginRight: "10px",
                    }}
                  />
                )}
              </div>
            );
          })}
        </Menu>
      </div>
    </>
  )
}
